import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid2';
import { faAngleRight, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Select from 'react-select';
function KnowledgeBase() {
    const navigate = useNavigate();
    
    const [roots, setRoots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [savesbtnloading, setSavesbtnloading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [name, setName] = useState('');
    const [selectedOwnedByGroup, setSelectedOwnedByGroup] = useState(null);
    const [selectedAccessGroups, setSelectedAccessGroups] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [error, setError] = useState('');
    const [errors1, setErrors1] = useState('');
    const [errors2, setErrors2] = useState('');
    const [rolesOptions, setRolesOptions] = useState([]);
    const [rolesrolelist, setRolesList] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [show, setShow] = useState(false);
    const [selectedRootId, setSelectedRootId] = useState(null);
    const handleClose = () => setShow(false);


    const fetchRoots = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const queryString = new URLSearchParams(params).toString();
            const response = await apiService.getRequest(`/knowledge-article-bases?${queryString}`);
            if (response && response.success === true) {
                setRoots(response.data);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await apiService.getRequest('admin/owned-groups-list');
                const options = response.data.map((role) => ({
                    value: role.id,  // Store role id instead of name
                    label: role.name,
                }));
                setRolesList(options);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
    }, []);
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await apiService.getRequest('admin/access-groups-list');
                const options = response.data.map((role) => ({
                    value: role.id,  // Store role id instead of name
                    label: role.name,
                }));
                setRolesOptions(options);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
    }, []);

    const handleSearch = () => {
        fetchRoots({ search: searchQuery });
        setCurrentPage(0);
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    const handleInputChange = (e) => {
        setName(e.target.value);
        if (error) {
          setError(''); // Clear the error when the user starts typing
        }
    };

    const handleOwnedByGroupChange = (selectedOptions) => {
        // const selectedValues = selectedOptions.map(option => option.value);
        setSelectedOwnedByGroup(selectedOptions);
    
        // Clear the Ownedby Group error when a group is selected
        if (errors1) {
            setErrors1('');  // Clear the error for ownedByGroup
        }
    };  
    
    // Handle selection change for Access Groups
    const handleAccessGroupsChange = (selectedOptions) => {
        const selectedValues = selectedOptions.map(option => option.value);
        setSelectedAccessGroups(selectedValues);
    
        if (selectedValues.length > 0 && errors2) {
            setErrors2('');  // Clear the error for ownedByGroup
        }
    };

    // Filter options for Ownedby Group (exclude selected Access Groups)
    const filteredOwnedByGroupOptions = rolesrolelist.filter(
        role => !selectedAccessGroups.includes(role.value)
    );

    // Filter options for Access Groups (exclude selected Ownedby Group)
    const filteredAccessGroupsOptions = rolesOptions.filter(
        role => selectedOwnedByGroup?.value !== role.value
    );

    const handleSubmit = async () => {

        let valid = true;

    // Name validation
    if (name.trim() === '') {
        setError('Please enter a knowledge base name.');
        valid = false;
    }

    // Ownedby Group validation
    if (selectedOwnedByGroup === null) {
        setErrors1('Please select at least one group for Ownedby Group.');
        valid = false;
    }
    // Access Groups validation
    // if (selectedAccessGroups.length === 0) {
    //     setErrors2('Please select at least one group for Access Groups.');
    //     valid = false;
    // }
    
    if (!valid) return;
        try {
            if (editMode && editId) {
                setSavesbtnloading(true);
                // Update the existing article
                const response = await apiService.patchRequest(`/knowledge-article-bases/${editId}`, {
                    name: name,
                    access_groups:selectedAccessGroups,
                    owned_by_groups:selectedOwnedByGroup.value,
                });
                if (response && response.success === true) {
                    setEditMode(false);
                    setEditId(null);
                    setName('');
                    setSelectedAccessGroups([]);
                    setSelectedOwnedByGroup([]);
                    fetchRoots();
                    setErrorMessage("");
                }else{
                    setError(response && response.errors.name);
                    setErrors1(response && response.errors.owned_by_groups);
                    setErrors2(response && response.errors.access_groups);
                    setErrorMessage(response && response.message);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } else {
                setSavesbtnloading(true);
                const response = await apiService.postRequest('/knowledge-article-bases', {
                    name: name,
                    access_groups:selectedAccessGroups,
                    owned_by_groups:selectedOwnedByGroup.value,
                });
                if (response && response.success) {
                    setName('');
                    setSelectedAccessGroups([]);
                    setSelectedOwnedByGroup([]);
                    fetchRoots();
                    setErrorMessage("");
                }else{
                    setError(response && response.errors.name);
                    setErrors1(response && response.errors.owned_by_groups);
                    setErrors2(response && response.errors.access_groups);
                    setErrorMessage(response && response.message);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }finally{
            setSavesbtnloading(false);
        }
    };
    const handleCancel = () => {
        setName('');
        setEditMode(false);
        setEditId(null);
        setSelectedAccessGroups([]);
        setSelectedOwnedByGroup([]);
    };
    const handleEdit = async (id) => {
        try {
            const response = await apiService.getRequest(`/knowledge-article-bases/${id}`);
            if (response && response.success) {
                setName(response.data.name); // Populate the form with the existing data
                setSelectedAccessGroups(response.data.access_groups);
                const selectedOwnedByGroup = rolesrolelist.find(option => option.value === response.data.owned_groups);
                setSelectedOwnedByGroup({
                    value: selectedOwnedByGroup?.value,
                    label: selectedOwnedByGroup?.label
                });
                setEditMode(true); // Enable edit mode
                setEditId(id); // Store the ID of the article being edited
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching article:', error);
        }
    };


    
    const handleShow = (rootId) => {
        setSelectedRootId(rootId);
        setShow(true);
    };

    const handleDelete = async () => {
        try {
            const response = await apiService.deleteRequest(`/knowledge-article-bases/${selectedRootId}`); // Call DELETE API
            if(response && response.success === true){
                setRoots(roots.filter(roots => roots.id !== selectedRootId)); // Remove deleted member from state
                toast(response.message || 'Knowledge Base deleted successfully!');
            }else{
                toast(response.message);
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log(err,"Failed to delete member");
        }
        handleClose();
    };

    const rows = roots.map((datas,index) => ({
        index:index+1,
        id: datas.id,
        name: datas.name,
        group: datas.owned_groups,
        access: datas.access_groups,
        
    }));
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const paginatedRows = rows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    const columns = [
        {
            field: 'index',
            headerName: '#',
            width: 80,
            filterable: false,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 200,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                    <button className='editbtnroot' onClick={() => handleEdit(params.row.id)}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                    <button className='trashbtnroot' onClick={() => handleShow(params.row.id)}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                </Grid>
            ),
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 300,
            filterable: true,
        },
        {
            field: 'group',
            headerName: 'Ownedby Group',
            width: 250,
            filterable: true,
        },
        {
            field: 'access',
            headerName: 'Access Groups',
            width: 250,
            filterable: true,
        },
    ];
    return (
        <div className='container-fluid px-0'>
            <div className='content_container'>
                <Grid size={{ sm: 12 }} container justifyContent="space-between" className="main_jobseeker">
                    <Grid size={{ sm: 12 }} container alignItems="center">
                        <Grid size={{ md: 8, xs: 12 }} container flexDirection="column" className="jobseekerhead">
                            <h3>Knowledge Base</h3>
                            <span><b onClick={() => navigate("/dashboard")}>Dashboard</b> 
                            <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            Manage Knowledge 
                            <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            Knowledge Base</span>
                        </Grid>
                    </Grid>
                    <Grid size={{ sm: 12 }} container justifyContent="space-between" className="flex-md-row-reverse">
                        <Grid size={{ sm: 4, xs: 12 }} container alignContent="flex-start" alignItems="flex-start" className="my-4 knowledge_baseboxes">
                            <h4>{editMode ? "Edit": "Add"} Knowledge Base</h4>
                            <Grid size={{ xs: 12 }} container justifyContent="flex-end" className="addlister_base mt-2 pt-2">
                                <label>Name<small className='red_starimpo'>*</small></label>
                                <input 
                                    placeholder="Knowledge Base Name"
                                    value={name}
                                    onChange={handleInputChange} 
                                    className='py-4'
                                />
                                {error && <p style={{ color: 'red', width: '100%' }}>{error}</p>}
                                <label>Ownedby Group<small className='red_starimpo'>*</small></label>
                                <Select
                                    name="ownedByGroup"
                                    value={selectedOwnedByGroup}
                                    onChange={handleOwnedByGroupChange}
                                    options={filteredOwnedByGroupOptions}
                                    className="basic-multi-select w-100"
                                    classNamePrefix="select"
                                    placeholder="Choose Ownedby Group..."
                                />
                                {errors1 && <p style={{ color: 'red', width: '100%' }}>{errors1}</p>}
                                <label>Access Groups</label>
                                <Select
                                    isMulti
                                    name="accessGroups"
                                    value={rolesOptions.filter(role => selectedAccessGroups.includes(role.value))}
                                    onChange={handleAccessGroupsChange}
                                    options={filteredAccessGroupsOptions}
                                    className="basic-multi-select w-100"
                                    classNamePrefix="select"
                                    placeholder="Choose Access Group..."
                                />
                                {errors2 && <p style={{ color: 'red', width: '100%' }}>{errors2}</p>}

                                {errorMessage && <p style={{ color: 'red', width: '100%', marginTop:"10px" }}>{errorMessage}</p>}
                                <button onClick={handleSubmit}>
                                {savesbtnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : <>{editMode ? 'Update' : 'Create'}</>}
                                </button>
                                {editMode && (
                                    <button className='cancel_btneditmode' onClick={handleCancel} style={{ marginLeft: '10px' }}>
                                        Cancel
                                    </button>
                                )}
                            </Grid>
                        </Grid>
                        <Grid size={{ md:7.8,sm: 6.8, xs: 12 }} container justifyContent="flex-end" alignContent="flex-start" className="my-4 knowledge_baseboxes">
                            <h4>Knowledge Bases</h4>
                            <Grid size={{ md: 8, xs: 12 }} container justifyContent="space-between" alignItems="center" className="mb-2">
                                <Grid size={{ xs: 12 }} container flexDirection="column">
                                    <div className='d-flex jobseekersearch my-3'>
                                        <div className='col-2'>
                                            <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                        </div>
                                        <div className='col-md-7 col-6'>
                                            <input type='text' placeholder='search'
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                      handleSearch(); // Trigger search on Enter key press
                                                    }
                                                }}
                                                />
                                        </div>
                                        <div className='col-md-3 col-4'>
                                            <button onClick={handleSearch}>Search</button>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <div className='overflowwer_fullwidth w-100'>
                                {loading ? 
                                    <div className='d-flex justify-content-center w-100'>
                                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                    {roots && roots.length > 0 ? (
                                        <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                                            <DataGrid
                                                style={{minHeight:"200px"}}
                                                rows={paginatedRows}
                                                columns={columns}
                                                pageSize={pageSize}
                                                disableSelectionOnClick
                                                components={{ Toolbar: GridToolbar }}
                                            />
                                        </Box>
                                    ) : (
                                        <div className="w-100 d-flex justify-content-center mt-4">
                                            <p>No data to display</p>
                                        </div>
                                    )}
                                </>}
                            </div>
                            <Grid size={{xs:12}} container className="datatable_jobpagi_indi">
                                <div className='d-flex flex-column w-100 my-3 pagination_datagrid'>
                                    <Grid size={{xs:12}} container justifyContent="space-between">
                                        <div className='d-flex justify-content-end align-items-center'>
                                            <label className='me-2'>Showing records <b>{rows.length === 0 ? 0 : currentPage * pageSize + 1}–{Math.min((currentPage + 1) * pageSize, rows.length)}</b> out of <b>{rows.length.toLocaleString()}</b></label>
                                        </div>
                                        <div className='d-flex justify-content-end align-items-center'>
                                            <label>No. of Rows</label>
                                            <select
                                                label="Rows per page"
                                                value={pageSize}
                                                onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                                sx={{ mr: 2 }}
                                            >
                                                {[5, 10, 20, 50].map((size) => (
                                                    <option key={size} value={size}>{size}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Grid>
                                    <div className="d-flex justify-content-center my-3">
                                        <button
                                            className='nexter_btns'
                                            variant="contained"
                                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                            disabled={currentPage === 0}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </button>
                    
                                        {/* Page number buttons */}
                                        <div className="d-flex align-items-center mx-2">
                                            {Array.from({ length: Math.ceil(rows.length / pageSize) }, (_, index) => (
                                                <button
                                                    key={index}
                                                    className={`page-btn ${currentPage === index ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(index)}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                    
                                        <button
                                            className='nexter_btns'
                                            variant="contained"
                                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(rows.length / pageSize) - 1))}
                                            disabled={currentPage >= Math.ceil(rows.length / pageSize) - 1}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </button>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete this Knowledge Base?</Modal.Body>
                    <Modal.Footer>
                        <button className='modal_cancel' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='modal_delete' onClick={handleDelete}>
                            Delete
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}

export default KnowledgeBase;
